<div class="container-inapp d-flex flex-column px-3 pb-2">

    <button (click)="cancel()" class="d-flex justify-content-end pt-3" type="button">
        <span class="svg-icon svg-icon-black d-flex align-items-center">
            <svg-icon src="/assets/icons/svg/close.svg"></svg-icon>
        </span>
    </button>

    <div class="title px-3 d-flex justify-content-center align-items-center mb-3">
        <span class=" text-center">
          ¡Califica tu experiencia!
        </span>
    </div>

    <div class="d-flex flex-column justify-content-center mb-3">
        <div class="d-flex options-qualifications">
            <button style="flex: 1; width: 100%;" (click)="onSubmit(option)" class="btn"
                *ngFor="let option of optionsQualifications">{{option.label}}</button>
        </div>
    </div>

    <div class="actions mb-3 d-flex justify-content-center">
        <div class="col-6">
            <button (click)="omitted()" class="ignore w-100" type="button">Omitir</button>
        </div>
    </div>
</div>
